// extracted by mini-css-extract-plugin
export default {"errormsg":"ErrorMsg_errormsg__1bEC7","getStylesForModelScreener":"ErrorMsg_getStylesForModelScreener__Jw4y1"};